import React from "react";
import SkillTag from "../components/SkillTag";
import { skills } from "../lib/data";
import type { Skill } from "../lib/types";

function SkillsSection() {
  const categories = Object.entries(skills);

  return (
    <div className="flex flex-col gap-8">
      <div className="opacity-0-start animate-fade-in-d1">
        <h2 className="text-xl font-bold mb-1">Skills</h2>
        <p className="text-base text-content-muted">
          Hover to see proficiency levels
        </p>
      </div>

      {categories.map(([category, items]: [string, Skill[]], ci: number) => (
        <div
          key={category}
          className={`opacity-0-start animate-fade-in-d${Math.min(ci + 2, 5)}`}
        >
          <h3 className="text-xs font-semibold text-content-muted uppercase tracking-widest font-mono mb-3">
            {category}
          </h3>
          <div className="flex flex-wrap gap-2">
            {items.map((s: Skill) => (
              <SkillTag key={s.name} name={s.name} level={s.level} />
            ))}
          </div>
        </div>
      ))}

      {/* Legend */}
      <div className="opacity-0-start animate-fade-in-d5 flex gap-4 flex-wrap text-2xs font-mono text-content-muted">
        <span className="flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-accent" /> Expert
        </span>
        <span className="flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-brand" /> Advanced
        </span>
        <span className="flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-warm" /> Intermediate
        </span>
      </div>
    </div>
  );
}

export default SkillsSection;